import { LAST_TOP_UP_METHOD_KEY } from '@/features/wallet/config.js';

/**
 * How the customer pays for a top-up (MYP-135), the old site's 付款方式:
 *
 * - `fpx`: online banking, through Fiuu (`molpay_pay`, MYP-134);
 * - `ewallet`: e-wallets and DuitNow QR, through Revenue Monster (the vendor's `rm_pay`, not built
 *   yet).
 *
 * The old site's third choice, 线下付款 (transfer and upload a slip, `chargehandle`), is its own
 * flow and not part of this card.
 */
export type TopUpMethod = 'fpx' | 'ewallet';

export const TOP_UP_METHODS: readonly TopUpMethod[] = ['fpx', 'ewallet'];

export function isTopUpMethod(value: unknown): value is TopUpMethod {
  return value === 'fpx' || value === 'ewallet';
}

/** The method last picked in this tab, guarded: storage can be off or throw (private browsing). */
export function readLastTopUpMethod(): TopUpMethod | undefined {
  try {
    const value = sessionStorage.getItem(LAST_TOP_UP_METHOD_KEY);
    return isTopUpMethod(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function saveLastTopUpMethod(method: TopUpMethod): void {
  try {
    sessionStorage.setItem(LAST_TOP_UP_METHOD_KEY, method);
  } catch {
    // Storage can be off; the card then starts on online banking.
  }
}
